import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-succesupdate-dialog',
  templateUrl: './succesupdate-dialog.component.html',
  styleUrls: ['./succesupdate-dialog.component.css'],
})
export class SuccesupdateDialogComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}
  close() {
    this.dialog.closeAll();
  }
}
